export enum UX_TRACKING_EVENT_NAMES {
  POST_SUBMISSION_SURVEY = 'postSubmissionSurveyTrigger',
}
